import { Phone, Mail, MapPin, Instagram, Clock, Siren } from "lucide-react";
import { Link } from "react-router-dom";
import { Seo } from "@/components/site/Seo";
import { PageHero } from "@/components/site/PageHero";
import { Reveal } from "@/components/site/Reveal";
import { BookingForm } from "@/components/book/BookingForm";
import { SITE } from "@/lib/site";

const ITEMS = [
  { I: Phone, label: "Phone", value: SITE.phone, href: SITE.tel, id: "contact-phone" },
  { I: Mail, label: "Email", value: SITE.email, href: `mailto:${SITE.email}`, id: "contact-email" },
  { I: MapPin, label: "Service area", value: SITE.area, id: "contact-area" },
  { I: Clock, label: "On-site & construction hours", value: `${SITE.hoursSite} · ${SITE.hoursSiteTime}`, id: "contact-hours" },
  { I: Siren, label: "24/7 service division", value: "24 hours · 7 days", note: "Blocked drains, jet blasting, CCTV camera inspections & emergencies", href: "/24-hour-service", internal: true, id: "contact-hours-247" },
  { I: Instagram, label: "Instagram", value: "@austyleplumbing", href: SITE.instagram, id: "contact-instagram" },
];

export default function Contact() {
  return (
    <>
      <Seo title="Contact Austyle Plumbing – Sydney Plumber 0452 538 075" description="Contact Austyle Plumbing on 0452 538 075 for domestic, commercial, industrial, strata and new build plumbing across Sydney, or send a quote request online." />
      <PageHero testid="contact-hero" eyebrow="Contact" lines={["Let's get", "it sorted."]} image="/images/ig/p10_12.jpg"
        intro="Call, email or send us the details below — we'll get back to you quickly." />
      <section className="bg-porcelain py-16 sm:py-24">
        <div className="container-x grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <ul className="border-t border-ink/15">
              {ITEMS.map(({ I, label, value, href, id, note, internal }, i) => (
                <Reveal as="li" key={label} delay={i * 0.05} className="border-b border-ink/15 py-6 flex gap-5">
                  <I className="h-5 w-5 text-cobalt mt-1 shrink-0" />
                  <div className="min-w-0">
                    <p className="eyebrow text-slate-500">{label}</p>
                    {internal ? <Link to={href} data-testid={id} className="block font-wide font-extrabold text-xl sm:text-2xl mt-1 hover:text-cobalt transition-colors">{value}</Link>
                      : href ? <a href={href} target={href.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer" data-testid={id} className="block font-wide font-extrabold text-xl sm:text-2xl mt-1 break-words hover:text-cobalt transition-colors">{value}</a>
                      : <p data-testid={id} className="font-wide font-extrabold text-xl sm:text-2xl mt-1">{value}</p>}
                    {note && <p className="text-sm text-slate-600 mt-1">{note}</p>}
                  </div>
                </Reveal>
              ))}
            </ul>
          </div>
          <div className="lg:col-span-7">
            <h2 className="font-wide font-black uppercase text-3xl sm:text-4xl tracking-tight mb-8">Send us a quote request</h2>
            <BookingForm defaultKind="quote" showToggle={false} />
          </div>
        </div>
      </section>
    </>
  );
}
